import React, { useEffect, useState } from "react";
import PageBanner from "../../components/PageBanner";
import BulletParagraph from "../../components/content/BulletParagraph";
import ServiceService from "../../services/service";
import { useParams } from "react-router-dom";

export default function ServiceDetail(props) {
  let [serviceData, setServiceData] = useState([]);
  let { id, lang } = useParams();

  //return lang function
  useEffect(() => {
    if (lang !== "th" && lang !== "en") {
      window.open(`${process.env.REACT_APP_WEB_URL}/th`, "_self");
    }
  });

  const getServiceData = async () => {
    try {
      let res = await ServiceService.getServiceByName(`/${id}`);

      if (res) {
        setServiceData(res);
      } else {
        window.open(`${process.env.REACT_APP_WEB_URL}/service`, "_self");
      }
    } catch {
      console.error();
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getServiceData();
    // eslint-disable-next-line
  }, []);

  function serviceTitle(text) {
    return (
      <h1 className="text-[28px] xl:text-[32px] text-left my-[50px] font-bold">
        {text}
      </h1>
    );
  }

  function serviceImage(data) {
    return (
      <div
        className={
          `flex gap-[46px] ` + (!data.imageIsLeft && "flex-row-reverse")
        }
      >
        <div
          className="!bg-cover !bg-center w-full rounded-[12px] min-h-[207px] bg-lightGray2"
          style={{
            background:
              data &&
              data.image &&
              `url(${process.env.REACT_APP_API_URL}${data.image.data.attributes.url}), #D9D9D9`,
          }}
        />
        <p className="w-full text-[20px] xl:text-[24px] whitespace-pre-line text-left">
          {lang === "th" ? data.detail[0].detail_TH : data.detail[0].detail_EN}
        </p>
      </div>
    );
  }

  const bannerText = [
    { name: "service", href: "/service" },
    {
      name: serviceData?.link?.label_EN,
    },
  ];

  return (
    <div className="service-info pt-[135px] lg:pt-[0px]">
      {serviceData.link ? (
        <PageBanner
          banner={serviceData.banner}
          text_th={`${serviceData.link.label_TH}`}
          text_en={`${serviceData.link.label_EN}`}
          bannerText={bannerText}
          lang={lang}
        />
      ) : (
        <PageBanner text_th={``} text_en={``} />
      )}

      <div className="section">
        <div className="page-container">
          {/* บริการ แยก */}
          <div className="mt-[92px] mb-[300px]">
            {serviceData.link && serviceData.link.label_TH && (
              <h1 className="text-[28px] xl:text-[32px] text-left">
                {lang === "th"
                  ? serviceData.link.label_TH
                  : serviceData.link.label_EN}
              </h1>
            )}
            <div>
              {serviceData.content &&
                serviceData.content.map((service, i) => (
                  <div key={i}>
                    {service.__component === "global.title" &&
                      serviceTitle(
                        lang === "th" ? service.title_th : service.title_en
                      )}

                    {service.__component === "global.image-content" &&
                      serviceImage(service)}

                    {service.__component === "global.detail" && (
                      <p className="text-[20px] xl:text-[24px] whitespace-pre-line text-left">
                        {lang === "th" ? service.detail_TH : service.detail_EN}
                      </p>
                    )}

                    {service.__component === "about.bullet" && (
                      <div className="mt-[32px]">
                        {BulletParagraph(
                          lang === "th" ? service.title_TH : service.title_EN,
                          lang === "th" ? service.detail_TH : service.detail_EN
                        )}
                      </div>
                    )}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
